import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-topping",
  "use": "icon-topping-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-topping\">\n<path d=\"M12.25 1.75H1.75V2.91667L12.25 2.91667V1.75Z\" />\n<path d=\"M10.3413 8.44977L11.1662 7.62476L7.04142 3.5L2.91667 7.62482L3.74162 8.44977L6.45808 5.73324L6.45802 12.2499L7.62469 12.25L7.62475 5.73324L10.3413 8.44977Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol